import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import ErrorBoundary from "./components/ErrorBoundary";

import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import PackagesSection from "./components/PackagesSection";
import SlangSection from "./components/SlangSection";
import BlogSection from "./components/BlogSection";
import CurrencyConverter from "./components/CurrencyConverter";
import RevenueCalculator from "./components/RevenueCalculator";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import AdminDashboard from "./components/AdminDashboard";

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <FeaturesSection />
        <PackagesSection />
        <ErrorBoundary fallbackMessage="The Slang section encountered an issue. Please try again.">
          <SlangSection />
        </ErrorBoundary>
        <ErrorBoundary fallbackMessage="The Blog section encountered an issue. Please try again.">
          <BlogSection />
        </ErrorBoundary>
        <ErrorBoundary fallbackMessage="The Revenue Calculator encountered an issue. Please try again.">
          <RevenueCalculator />
        </ErrorBoundary>
        <ErrorBoundary fallbackMessage="The Currency Converter encountered an issue. Please try again.">
          <CurrencyConverter />
        </ErrorBoundary>
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

const AdminPage = () => {
  const navigate = useNavigate();
  return (
    <ErrorBoundary fallbackMessage="The Admin Dashboard encountered an issue. Please try again.">
      <AdminDashboard onBack={() => navigate('/')} />
    </ErrorBoundary>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
